import { render } from "./FormView.vue?vue&type=template&id=cbefa536&scoped=true"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"

import "./FormView.vue?vue&type=style&index=0&id=cbefa536&scoped=true&lang=scss"

import exportComponent from "/home/timecard-prod/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbefa536"]])

export default __exports__